import {
    GET_SERVICES,
    GET_SERVICES_SUCCESS,
    GET_SERVICES_FAILURE,
    UPDATE_SERVICE_STATUS,
    UPDATE_SERVICE_STATUS_SUCCESS,
    UPDATE_SERVICE_STATUS_FAILURE,
    DELETE_SERVICE,
    DELETE_SERVICE_SUCCESS,
    DELETE_SERVICE_FAILURE,
    ADD_SERVICE,
    ADD_SERVICE_SUCCESS,
    ADD_SERVICE_FAILURE,
    EDIT_SERVICE,
    EDIT_SERVICE_SUCCESS,
    EDIT_SERVICE_FAILURE,
    SERVICE_DETAILS,
    SERVICE_DETAILS_SUCCESS,
    SERVICE_DETAILS_FAILURE,
    QUESTION_DROPDOWN_LIST,
    QUESTION_DROPDOWN_LIST_SUCCESS,
    QUESTION_DROPDOWN_LIST_FAILURE,
    UPDATE_SERVICES_ORDER_STATUS,
    UPDATE_SERVICES_ORDER_STATUS_SUCCESS,
    UPDATE_SERVICES_ORDER_STATUS_FAILURE,
    RESET_ADD_SERVICE_DATA
} from "../Constants";

export const GetServices = (payload) => ({
    type: GET_SERVICES,
    payload
});

export const GetServicesSuccess = (payload) => ({
    type: GET_SERVICES_SUCCESS,
    payload
});

export const GetServicesFailure = (payload) => ({
    type: GET_SERVICES_FAILURE,
    payload
});

export const UpdateServiceStatus = (payload) => ({
    type: UPDATE_SERVICE_STATUS,
    payload
});

export const UpdateServiceStatusSuccess = (payload) => ({
    type: UPDATE_SERVICE_STATUS_SUCCESS,
    payload
});

export const UpdateServiceStatusFailure = (payload) => ({
    type: UPDATE_SERVICE_STATUS_FAILURE,
    payload
});

export const DeleteService = (payload) => ({
    type: DELETE_SERVICE,
    payload
});

export const DeleteServiceSuccess = (payload) => ({
    type: DELETE_SERVICE_SUCCESS,
    payload
});

export const DeleteServiceFailure = (payload) => ({
    type: DELETE_SERVICE_FAILURE,
    payload
});

export const AddService = (payload) => ({
    type: ADD_SERVICE,
    payload
});

export const AddServiceSuccess = (payload) => ({
    type: ADD_SERVICE_SUCCESS,
    payload
});

export const AddServiceFailure = (payload) => ({
    type: ADD_SERVICE_FAILURE,
    payload
});

export const EditService = (payload) => ({
    type: EDIT_SERVICE,
    payload
});

export const EditServiceSuccess = (payload) => ({
    type: EDIT_SERVICE_SUCCESS,
    payload
});

export const EditServiceFailure = (payload) => ({
    type: EDIT_SERVICE_FAILURE,
    payload
});

export const ServiceDetails = (payload) => ({
    type: SERVICE_DETAILS,
    payload
});

export const ServiceDetailsSuccess = (payload) => ({
    type: SERVICE_DETAILS_SUCCESS,
    payload
});

export const ServiceDetailsFailure = (payload) => ({
    type: SERVICE_DETAILS_FAILURE,
    payload
});

export const QuestionDropdownList = () => ({
    type: QUESTION_DROPDOWN_LIST
});

export const QuestionDropdownListSuccess = (payload) => ({
    type: QUESTION_DROPDOWN_LIST_SUCCESS,
    payload
});

export const QuestionDropdownListFailure = (payload) => ({
    type: QUESTION_DROPDOWN_LIST_FAILURE,
    payload
});

export const UpdateServiceOrderStatus = (payload) => ({
    type: UPDATE_SERVICES_ORDER_STATUS,
    payload
});

export const UpdateServiceOrderStatusSuccess = (payload) => ({
    type: UPDATE_SERVICES_ORDER_STATUS_SUCCESS,
    payload
});

export const UpdateServiceOrderStatusFailure = (payload) => ({
    type: UPDATE_SERVICES_ORDER_STATUS_FAILURE,
    payload
});

export const ResetAddServiceData = ()=>({
    type:RESET_ADD_SERVICE_DATA
})